import React from "react";
import { Box } from "@mui/material";
import Topbar from "../Topbar"; // Keep the existing topbar
import MuiSidebar from "../Sidebar/MuiSidebar";

const MuiLayout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        position: "relative",
        overflow: "visible",
      }}
    >
      <MuiSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          bgcolor: "#F5F6FA",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
          width: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Topbar />
        <Box
          sx={{
            flexGrow: 1,
            overflow: "auto",
            width: "100%",
            height: "calc(100vh - 64px)", // Adjust based on your header height
            p: 0,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default MuiLayout;
